import { render, staticRenderFns } from "./RealTimeAirQuality.vue?vue&type=template&id=6ad0b9c4&scoped=true&"
import script from "./RealTimeAirQuality.vue?vue&type=script&lang=js&"
export * from "./RealTimeAirQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0b9c4",
  null
  
)

export default component.exports